export const requiredFieldsByStep = {
  VEHICLE: [
    "vehicleOdometer",
    "vehicleLicensePlate",
    "vehicleId",
    "vehicleModel",
    "emissionStandard",
  ],

  DRIVER: [],

  DEALERSHIP: [],

  CALL: [
    "vehicleOdometer",
    "vehicleLicensePlate",
    "vehicleModel",
    "dealershipDn",
    "criticality",
    "vehicleStopped",
    "occurrenceType",
    "country",
    "hasLink",
    "mainOccurrence",
    "failures",
    "vehicleCriticalPayload",
    "emissionStandard",
  ],
  CALL_PREVENTIVE_CHECKUP: [
    "vehicleOdometer",
    "vehicleLicensePlate",
    "vehicleModel",
    "dealershipDn",
    "criticality",
    "emissionStandard",
  ],

  SCREENING: ["vehicleStopped"],
  SCREENING_PREVENTIVE_CHECKUP: [],

  DISPLACEMENT: [
    "vehicleStopped",
  ],
  DISPLACEMENT_PREVENTIVE_CHECKUP: ["vehicleStopped"],

  SECOND_DIAGNOSIS: [
    "vehicleStopped",
    "hasLink",
    "mainOccurrence",
  ],
  SECOND_DIAGNOSIS_PREVENTIVE_CHECKUP: [],

  REMOVAL: [
    "vehicleStopped",
    "hasLink",
    "mainOccurrence",
  ],
  REMOVAL_PREVENTIVE_CHECKUP: [],

  THIRD_DIAGNOSIS: ["vehicleStopped"],
  THIRD_DIAGNOSIS_PREVENTIVE_CHECKUP: [],

  FOURTH_DIAGNOSIS: ["vehicleStopped", "tasNumber"],
  FOURTH_DIAGNOSIS_PREVENTIVE_CHECKUP: [],

  ANALYSIS_WARRANTY: ["vehicleStopped"],
  ANALYSIS_WARRANTY_PREVENTIVE_CHECKUP: [],

  CUSTOMER_OK: ["vehicleStopped"],
  CUSTOMER_OK_PREVENTIVE_CHECKUP: [],

  PARTS: [],
  PARTS_PREVENTIVE_CHECKUP: [],

  PARTS_IN_TRANSIT: ["vehicleStopped"],
  PARTS_IN_TRANSIT_PREVENTIVE_CHECKUP: [],

  AWAITING_REPAIR: ["vehicleStopped"],
  AWAITING_REPAIR_PREVENTIVE_CHECKUP: [],

  REPAIR: ["vehicleStopped"],
  REPAIR_PREVENTIVE_CHECKUP: [],

  RELEASE: ["vehicleStopped"],
  RELEASE_PREVENTIVE_CHECKUP: [],
};
